import React from 'react';
import { StarIcon } from 'lucide-react';
interface Testimonial {
  name: string;
  content: string;
}
export const TestimonialSection = () => {
  const testimonials: Testimonial[] = [{
    name: 'Amanda B – Verified Buyer',
    content: "Was tired of trackers that overwhelmed me with charts. Zenora's sleep and stress scores are so clear. Actually know what to do to feel better."
  }, {
    name: 'James L – Verified Buyer',
    content: "Switched from a subscription wearable that kept charging me extra. This just works. Data is reliable, battery is solid. I barely notice it's on."
  }, {
    name: 'Sophie M – Verified Buyer',
    content: "Other trackers made me dig for answers. Zenora's app just shows what matters. Stress tracking was eye-opening. No fees is a huge win."
  }, {
    name: 'David K – Verified Buyer',
    content: "Couldn't stand sleeping with a chunky watch. This ring is subtle and super comfortable. The data actually feels trustworthy."
  }, {
    name: 'Emily R – Verified Buyer',
    content: 'Feels like an actual investment in my health instead of a money pit. Battery lasts, no surprise fees, and the insights really changed my routine.'
  }];
  return <section className="py-12 border-t border-gray-200" data-id="element-57">
      <div className="space-y-6" data-id="element-58">
        {testimonials.map((testimonial, index) => <div key={index} className="bg-gray-50 p-6 shadow-sm" data-id="element-59">
            <div className="mb-2" data-id="element-60">
              <h3 className="font-semibold text-gray-900" data-id="element-61">
                {testimonial.name}
              </h3>
              <div className="flex text-yellow-400" data-id="element-62">
                <StarIcon className="h-5 w-5 fill-current" data-id="element-63" />
                <StarIcon className="h-5 w-5 fill-current" data-id="element-64" />
                <StarIcon className="h-5 w-5 fill-current" data-id="element-65" />
                <StarIcon className="h-5 w-5 fill-current" data-id="element-66" />
                <StarIcon className="h-5 w-5 fill-current" data-id="element-67" />
              </div>
            </div>
            <p className="text-gray-700" data-id="element-68">"{testimonial.content}"</p>
          </div>)}
      </div>
    </section>;
};